import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Marker from 'react-google-maps/lib/components/Marker';
import _some from 'lodash/some';

// Assets
import placemarktIcon from '../assets/pizzeria-pin.svg';

// Config
import config from '../../../config';

class MapPlacemarks extends PureComponent {
  static defaultProps = {
    item: [],
    selectedPolygonId: undefined,
  };

  static propTypes = {
    item: PropTypes.object.isRequired,
    markerHover: PropTypes.func.isRequired,
    selectedPolygonId: PropTypes.any,
    allMarkersVisible: PropTypes.bool,
  };

  onMouseLeave = () => this.props.markerHover(false);

  onMouseEnter = () => this.props.markerHover(true);

  render() {
    const { item, allMarkersVisible, selectedPolygonId } = this.props;

    const markerCoords = new google.maps.LatLng(parseFloat(item.coordinates[1]), parseFloat(item.coordinates[0]));

    return (
      <React.Fragment>
        <Marker
          position={markerCoords}
          icon={placemarktIcon}
          visible={
            selectedPolygonId !== undefined
              ? item.areas_details.length &&
                _some(item.areas_details, { polygon_id: selectedPolygonId })
              : allMarkersVisible
          }
          draggable={false}
          onMouseOver={this.onMouseEnter}
          onMouseOut={this.onMouseLeave}
        />
      </React.Fragment>
    );
  }
}

export default MapPlacemarks;
